module.exports = new __parcel__URL__("gallery_2.f8daf0fa.jpg").toString();